<script>
import CompanyResource from '@/resources/company'
import MarketResource from '@/resources/market'

export default {
    computed: {
        sizeOptions() {
            return Object.keys(CompanyResource.sizeOptions).map((key) => {
                return { value: key, text: CompanyResource.sizeOptions[key] }
            })
        },
    },
    data() {
        return {
            loading: false,
            formState: {},
            marketOptions: [{ value: null, text: 'Not Sure' }],
            form: {
                name: null,
                description: '',
                size: 0,
                website: '',
                market: null,
            },
        }
    },
    props: {
        showSubmit: {
            type: Boolean,
            default: true,
        },
        submitText: {
            type: String,
            default: 'Submit',
        },
        companyResource: {
            type: CompanyResource,
            default() {
                return new CompanyResource()
            }
        }
    },
    methods: {
        onSubmit() {
            if (this.formState.$invalid) {
                return false
            }
            
            for(let key in this.form) {
                this.companyResource.attributes[key] = this.form[key]
            }

            this.$emit('success', this.companyResource)
        },
        onInput(e) {
            this.$emit('input', this.form, this.formState)
        },
        async hydrateForm(resource) {
            for (let key in this.form) {
                this.form[key] = resource.attributes[key]
            }
        }
    },
    async mounted() {
        let markets = await MarketResource.all()
        this.marketOptions = this.marketOptions.concat(
            markets.map((marketResource) => {
                return {
                    value: marketResource.id,
                    text: marketResource.get('name'),
                }
            })
        )

        if ('object' === typeof this.companyResource && !this.companyResource.isNew()) {
            await this.hydrateForm(this.companyResource)
        }
    },
}
</script>

<template>
    <vue-form :state="formState" @submit.prevent="onSubmit">
        <validate auto-label>
            <b-form-group label="Company Name">
                <b-form-input name="companyName" v-model="form.name" required @input="onInput" />
                <field-messages name="companyName" show="$submitted">
                    <div slot="required" class="text-danger">This field is required</div>
                </field-messages>
            </b-form-group>
        </validate>

        <b-form-group label="Company Description">
            <b-form-textarea name="description" v-model="form.description" rows="6" @input="onInput" />
        </b-form-group>

        <validate auto-label>
            <b-form-group label="Company Size">
                <b-form-select name="size" v-model="form.size" :options="sizeOptions" @input="onInput" required />
                <field-messages name="size" show="$submitted">
                    <div slot="required" class="text-danger">This field is required</div>
                </field-messages>
            </b-form-group>
        </validate>

        <b-form-group label="Market">
            <b-form-select name="market" v-model="form.market" :options="marketOptions" :disabled="marketOptions.length < 1" @input="onInput" />
        </b-form-group>

        <validate auto-label>
            <b-form-group label="Company Website">
                <b-form-input type="url" name="website" v-model="form.website" @input="onInput" />
                <field-messages name="website" show="$submitted">
                    <div slot="required" class="text-danger">This field is required</div>
                    <div slot="url" class="text-danger">A valid URL is required (https://...)</div>
                </field-messages>
            </b-form-group>
        </validate>

        <slot name="submit" v-if="showSubmit" :handler="onSubmit">
            <b-button type="submit" variant="primary" size="lg">{{ submitText }}</b-button>
        </slot>
    </vue-form>
</template>
